/**
 * Deterministic time helpers. Domain code never reads an ambient clock:
 * every operation receives `now` (epoch milliseconds) or explicit instants.
 */

export const MS_PER_SECOND = 1_000
export const MS_PER_MINUTE = 60 * MS_PER_SECOND
export const MS_PER_HOUR = 60 * MS_PER_MINUTE
export const MS_PER_DAY = 24 * MS_PER_HOUR

/** Parse an ISO-8601 instant. Throws on invalid input (programming error, not user data). */
export function instant(iso: string): number {
  const ms = Date.parse(iso)
  if (Number.isNaN(ms)) {
    throw new TypeError(`instant() requires a valid ISO-8601 datetime, received: ${iso}`)
  }
  return ms
}

export function toIso(ms: number): string {
  return new Date(ms).toISOString()
}

/** Half-open window check: [start, end). */
export function inWindow(atMs: number, startMs: number, endMs: number): boolean {
  return atMs >= startMs && atMs < endMs
}
